import React, { Component } from "react";

import {
  HomeSlider,
  HomeTitle,
  Img,
  CoverSection,
  ResponsiveYouTubeIframe,
} from "../../Components/UI/UI";

import { getWeather, asyncgetWeather, isMobile } from "../../Utility/Utility";

import Menu from "../../Components/Menu/Menu";
import Footer from "../../Components/Footer/Footer";

import "./CoronaVirus.css";

class CoronaVirus extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    Promise.all([asyncgetWeather()]).then((response) => {
        var weather = response[0];
     

    
        // console.log(typeof weather);
        // console.log( weather);

        const jerusalemTemperature = '20';
        const deadSeaTemperature = '20';
        const telAvivTemperature = '20';
        const telAvivWaterTemp = '20';

        if (typeof weather !== 'object') {
            // console.log('The weather variable is a string.');
            
            // Find the starting index of the JSON object
            const jsonStartIndex = weather.indexOf('{"jerusalem"');
    
            if (jsonStartIndex !== -1) {
                  // Extract the JSON substring
                  const jsonString = weather.substring(jsonStartIndex);
      
                  // Log the extracted JSON string to verify
                  // console.log('Extracted JSON String:', jsonString);
      
                  try {
                      const weatherData = JSON.parse(jsonString);
                      // console.log('Parsed Weather Data:', weatherData);
      
                      // Accessing the required temperature values
                      const jerusalemTemperature = weatherData.jerusalem.temperature;
                      const deadSeaTemperature = weatherData.deadsea.temperature;
                      const telAvivTemperature = weatherData.telaviv.temperature;
                      const telAvivWaterTemp = weatherData.telaviv.water_temp;
      
                      // console.log('Jerusalem Temperature:', jerusalemTemperature);
                      // console.log('Dead Sea Temperature:', deadSeaTemperature);
                      // console.log('Tel Aviv Temperature:', telAvivTemperature);
                      // console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
      
                      // Set the state with the extracted values
                      this.setState({
                        
                          jerusalemWeather: jerusalemTemperature,
                          deadSeaWeather: deadSeaTemperature,
                          telAvivWeather: telAvivTemperature,
                          waterTemp: telAvivWaterTemp,
                      });
      
                  } catch (error) {
                      console.error('Error parsing JSON:', error);
                  }
              } else {
                  console.error('No JSON found in the weather response');
                  this.setState({
                    jerusalemWeather: jerusalemTemperature,
                    deadSeaWeather: deadSeaTemperature,
                    telAvivWeather: telAvivTemperature,
                    waterTemp: telAvivWaterTemp,
                });
              }
        } else {
            // console.log('The weather variable is an object.');
            this.setState({
                jerusalemWeather: weather.jerusalem.temperature,
                deadSeaWeather: weather.deadsea.temperature,
                telAvivWeather: weather.telaviv.temperature,
                waterTemp: weather.jerusalem.water_temp,
            });
        }

    });

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions);
}

  render() {
    return (
      <div className="page align-left page-Corona-virus">
        <Menu />
        {/*<HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />*/}
        {!isMobile() ? (
          <CoverSection
            desktopImg={"/HomeSlider/corona.jpg"}
            mobileImg={"/HomeSlider/M/uk/4.jpg"}
            cssClass={"north"}
            waterTemp={this.state.waterTemp}
            telAvivWeather={this.state.telAvivWeather}
            jerusalemWeather={this.state.jerusalemWeather}
          />
        ) : (
          <div className="ac-corona-mobile-video">
            <ResponsiveYouTubeIframe vidId={"yE5MV_10cZw"} />
          </div>
        )}

        <div className="container">
          <div className="ac-new-container">
            <div className="ac-new-container">
              <h2 className="ac-pink"></h2>
              <h2 className="ac-pink ac-pink ac-margin-top-1 ac-bigger">
                Heureux de vous revoir!
              </h2>
              <h2>
                <span>
                  <strong>
                    Voyage en Israël pour les ressortissants étrangers vaccinés
                    (vaccination complète)
                  </strong>
                </span>
              </h2>
              <br />
              Depuis le 1er novembre 2021, les ressortissants étrangers qui sont
              vaccinés (vaccination complète) seront autorisés à entrer en
              Israël sous réserve des conditions suivantes:
              <ul>
                <li>
                  1. Vous n’étiez pas dans un pays de la zone rouge au cours des
                  14 jours précédant votre arrivée en Israël.
                </li>
                <li>
                  2. Vous êtes vacciné avec un vaccin reconnu par l’OMS sous
                  réserve des conditions définies ci-dessous.
                </li>
                <li>
                  3. L’entrée en Israël se fait uniquement par l’aéroport
                  Tel-Aviv/Ben Gourion.
                </li>
                <li>
                  4. Il n’existe aucun autre obstacle à votre entrée en Israël.
                </li>
                <li>
                  5. Les ressortissants étrangers qui ne remplissent pas les
                  conditions ci-dessus peuvent encore demander d’entrer en
                  Israël en passant par le{" "}
                  <a
                    href="https://survey.gov.il/he/PCR2"
                    target="_blank"
                    rel="noopener"
                  >
                    Comité des exceptions
                  </a>
                </li>
              </ul>
              <h2 className="ac-pink">Vaccins homologués</h2>
              <br />
              <p className="ac-align-left-15">
                Les vaccins suivants sont approuvés par Israël: Moderna, Pfizer,
                Johnson & Johnson – Janssen, AstraZeneca, Covishield, Sinopharm,
                Sinovac, SputniK-V (sous réserve des conditions ci-dessous)
              </p>
              <br />
              <p className="ac-align-left-15">
                <strong>
                  Quelles personnes sont reconnues par Israël comme étant
                  complètement vaccinées?
                </strong>
              </p>
              <p className="ac-align-left-15">
                Les ressortissants étrangers ayant effectué une vaccination avec
                Pfizer/Moderna/AstraZeneca/Sinovac ou Sinopharm:
              </p>
              <ul>
                <li>
                  ● Si vous avez effectué une vaccination complète de deux
                  injections de vaccin, au moins 14 jours doivent s’être écoulés
                  entre la deuxième dose et votre entrée en Israël (mais pas
                  plus de 180 jours à votre sortie d’Israël).
                </li>
                <li>
                  ● Si vous avez reçu la troisième dose, au moins 14 jours
                  doivent s’être écoulés entre la troisième dose et votre entrée
                  en Israël.
                </li>
              </ul>
              &nbsp;
              <p className="ac-align-left-15">
                Les ressortissants étrangers ayant reçu les vaccins Johnson &
                Johnson – Janssen:
              </p>
              <ul>
                <li>
                  ● au moins 14 jours doivent s’être écoulés depuis la date de
                  vaccination (mais pas plus de 180 jours à votre sortie
                  d’Israël).
                </li>
                <li>
                  ● Si vous avez reçu la troisième dose, au moins 14 jours
                  doivent s’être écoulés entre la troisième dose et votre entrée
                  en Israël.
                </li>
              </ul>
              &nbsp;
              <p className="ac-align-left-15">
                Les ressortissants étrangers ayant reçu le vaccin Sputnik:
              </p>
              <ul>
                <li>
                  ● Les ressortissants étrangers qui ont reçu le vaccin Sputnik
                  à compter du 15/11/21 et dont le test sérologique antigénique
                  COVID effectué en Israël est négatif par manque d’anti-corps
                  (vous devez rester en quarantaine jusqu’à l’obtention d’un
                  résultat positif).
                </li>
                <li>
                  ● Vous devez avoir effectué une vaccination complète de deux
                  injections, au moins 14 jours doivent s’être écoulés entre la
                  deuxième dose et votre entrée en Israël (mais pas plus de 180
                  jours à votre sortie d’Israël).
                </li>
                <li>
                  ● Si vous avez reçu la troisième dose, au moins 14 jours
                  doivent s’être écoulés entre la troisième dose et votre entrée
                  en Israël.
                </li>
              </ul>
              <h2>
                <strong>
                  Entrée en Israël pour les personnes complètement guéries de la
                  COVID-19
                </strong>
              </h2>
              <br />
              <p className="ac-align-left-15">
                Les ressortissants étrangers qui sont guéris de la COVID seront
                autorisés à entrer en Israël s'ils possèdent un certificat
                numérique qui peut être authentifié par les systèmes du
                ministère israélien de la Santé et sur la base d'un résultat
                positif à un test NAAT (test moléculaire similaire au PCR).
              </p>
              <ul>
                <li>
                  ● Au moins 11 jours doivent s’être écoulés entre la date du
                  résultat de test positif et votre entrée en Israël (mais pas
                  plus de 190 jours à votre sortie d’Israël){" "}
                </li>
                <li>
                  ● Vous devez avoir reçu au moins une dose d’un vaccin reconnu
                  par l’OMS (l’ordre des évènements n’a pas d’importance).
                </li>
              </ul>
              <a href="#_ednref1" name="_edn1"></a>
              <b>
                * Entry for recoverees is only applicable for those coming from
                countries that issue certificates that the Israeli MOH systems
                can digitally authenticate, which is not available for people
                traveling from the USA or Canada
              </b>
              <h2>
                <strong>Procédure d’entrée en Israël</strong>
              </h2>
              <br />
              <ul className="ac-wrpr-num">
                <li className="ac-num-li">
                  1. Vous devez effectuer un test PCR au plus 72 heures avant
                  votre vol
                </li>
                <li className="ac-num-li">
                  2. Vous devez remplir une déclaration de passager avant
                  d’entrer en Israël.
                  <ul>
                    <li>
                      ● Les passagers en possession d'un certificat numérique
                      vérifiable devront scanner ou télécharger leur certificat
                      de vaccination ou de guérison sur le formulaire du
                      passager entrant et ils recevront un pass-sanitaire avant
                      d’embarquer sur le vol.
                    </li>
                    <li>
                      ● Les passagers qui n'ont pas de certificat numérique
                      vérifiable déclareront leur statut vaccinal dans le
                      formulaire du passager entrant et rempliront une demande
                      pour raccourcir la période de quarantaine. Ils joindront
                      ensuite les documents adéquats pour recevoir le
                      pass-sanitaire avant d’embarquer sur le vol.
                    </li>
                  </ul>
                </li>
                <li className="ac-num-li">
                  3. Les documents suivants devront être présentés à
                  l’embarquement
                  <ul>
                    <li>
                      ● Test PCR négatif réalisé au plus 72 heures avant le vol.
                    </li>
                    <li>
                      ● Confirmation d’accord d’une déclaration de passager
                      entrant.
                    </li>
                    <li>
                      ● Certificat de vaccination attestant de la vaccination
                      conformément aux dispositions ci-dessus.
                    </li>
                    <li>
                      ● Certificat de guérison qui peut être authentifié par les
                      systèmes du ministère israélien de la Santé, indiquant la
                      guérison conformément aux dispositions définies ci-dessus.
                    </li>
                    <li>
                      ● Certificat numérique attestant de la guérison de la
                      COVID conformément aux dispositions ci-dessus.{" "}
                    </li>
                    <li>
                      ● Permis d’entrée exceptionnelle délivré par le ministère
                      israélien de l’Intérieur (exceptions, grandes lignes,
                      groupes)
                    </li>
                  </ul>
                </li>
                <li className="ac-num-li">
                  4. Des tests aléatoires de conformité de documents seront
                  effectués par l'Autorité de l'aéroport Ben Gourion.{" "}
                </li>
                <li className="ac-num-li">
                  5. Un test PCR doit être effectué à l'atterrissage à
                  l'aéroport Ben Gourion. Vous devrez entrer en quarantaine
                  jusqu'à l’obtention d’un résultat négatif, (ou pendant 24
                  heures maximum).
                </li>
                <li className="ac-num-li">
                  6. Les voyageurs ayant reçu les vaccins Spoutnik doivent
                  effectuer un test sérologique à l'aéroport Ben Gourion et
                  entrer en quarantaine jusqu'à l'obtention d'un résultat de
                  test positif (en plus de l'isolement imposé jusqu'à
                  l'obtention d'un résultat négatif du test PCR effectué à
                  l'atterrissage).
                </li>
              </ul>
              <br />
              <p className="ac-align-center">
                Pour consulter la liste des pays qui délivrent des certificats
                que les systèmes du ministère israélien de la Santé peuvent
                authentifier numériquement:
                <br />
                <a
                  href="https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en"
                  target="_blank"
                  rel="noopener"
                  className="ac-align-center"
                >
                  https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en
                </a>
              </p>
              <br />
              <p className="ac-align-center">
                Pour obtenir les détails complet du protocole d’entrée, cliquez
                ici:
                <br />
                <a
                  href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"
                  className="ac-align-left-15"
                  target="_blank"
                  rel="noopener"
                >
                  https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air
                </a>
              </p>
              <br />
              <p className="ac-align-center">
                <strong>
                  <span>
                    Les directives susmentionnées sont détaillées ici pour votre
                    information et votre bénéfice. En cas de doute,
                    veuillez-vous reporter aux directives publiées sur le site
                    du ministère israélien de la Santé qui contient les
                    informations les plus récentes et les plus précises.
                  </span>
                </strong>
                <br />{" "}
                <a
                  href="https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air"
                  className="ac-align-center"
                  target="_blank"
                  rel="noopener"
                >
                  https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air
                </a>
              </p>
              <h2 className="ac-pink">Nous espérons vous voir bientôt</h2>
            </div>

            <div className="ac-inner-video">
              <ResponsiveYouTubeIframe vidId={"LSb4Lmuw_Kw"} />
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default CoronaVirus;



// WEBPACK FOOTER //
// ./src/Pages/CoronaVirusPage/CoronaVirus.js